import { render, staticRenderFns } from "./modal-with-horizontal-icon.mpx?vue&type=template&id=41ea5de0&isComponent&outputPath=components%2Fmodal-with-horizontal-icon0ef613e0%2Findex"
import script from "./modal-with-horizontal-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-with-horizontal-icon0ef613e0%2Findex"
export * from "./modal-with-horizontal-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-with-horizontal-icon0ef613e0%2Findex"
import style0 from "./modal-with-horizontal-icon.mpx?vue&type=style&index=0&id=41ea5de0&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_0ef613e0%22%7D&isComponent&outputPath=components%2Fmodal-with-horizontal-icon0ef613e0%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports